var exports = {
  "wx": "xaee3c4fa--0e75e7--header",
  "iE": "xaee3c4fa--0e75e7--wrapper",
  "pz": "xaee3c4fa--0e75e7--sidebar",
  "rf": "xaee3c4fa--0e75e7--body",
};

module.exports = exports;
